import { IPriceOverrideConfigResponse } from "../typings/interfaces/responses/priceOverrideConfigResponse";

type ProcessingFlags = { pressOnly?: boolean; cleanOnly?: boolean };

// The price override for an item at `price` in service `categoryId`.
//
// Press Only / Clean Only bands (client table: $0-30, $30-100, $100-300) use
// the highest band whose minimum is at or below the price: a price on an
// edge ($30.00, $100.00) gets the upper band, anything above the top band
// ($300+) keeps the top band's rate, and a gap between bands ($29.99 -> $30)
// can't leave an item unpriced. They win over general (ALL) overrides.
//
// General overrides keep matching inclusively on both ends, as before.
export const findPriceOverride = (
  configs: IPriceOverrideConfigResponse[],
  categoryId: number | undefined,
  price: number,
  item: ProcessingFlags
): IPriceOverrideConfigResponse | undefined => {
  const forService = configs.filter((config) => config.categoryId === categoryId);

  const processingType = item.pressOnly ? "PRESS_ONLY" : item.cleanOnly ? "CLEAN_ONLY" : null;
  if (processingType) {
    const band = forService
      .filter((config) => config.processingType === processingType && config.slabMinPrice <= price)
      .sort((a, b) => b.slabMinPrice - a.slabMinPrice)[0];
    if (band) return band;
  }

  return forService.find(
    (config) =>
      (!config.processingType || config.processingType === "ALL") &&
      price >= config.slabMinPrice &&
      price <= config.slabMaxPrice
  );
};
